import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Button, Col, Row, Modal, Image } from 'react-bootstrap';
import MenuIcon from '@material-ui/icons/Menu';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router-dom';
import { HoursofItemAvailability } from '../../../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/BusinessHoursMultiplePopup';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import {
  delete_item_from_category,
  get_category_menu_setup,
} from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import { delete_category_menu_setup } from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';

import {
  SET_CURRENT_ITEM_CATEGORY,
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  GET_VENDOR_MENU_CATEGORY_ITEMS,
  SET_PRODUCT_CLASSIFCATION,
  SET_PRODUCT_ACTIVE_CATID,
  BUSINESS_DETAILS_STEP,
} from '../../../../../../../store/types';
import Alert from 'react-s-alert';
import { DEFAULT_ITEM_IMAGE } from '../../../../../../../enums/GlobalEnums';
import { NOTAVAILABLEIMAGE } from '../../../../../../../enums/GlobalEnums';
import { AmealioLoader } from '../../../../../../Loader/AmealioLoader';
import isEmpty from '../../../../../../../store/validation/is-Empty';
import store from '../../../../../../../store/store';
import {
  REORDER_VENDOR_MENU_ITEM,
  REORDER_VENDOR_MENU_ITEM_STATUS,
} from '../../../../../../../store/types';
import { ITEMTYPEVEG } from '../../../../../../../enums/OrderEnums';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { amApi } from '../../../../../../../api/apiHelper';
import { errorAlert, successAlert } from '../../../../../../../function/alert';

const MenuSetupItem = (props) => {
  //state
  const [menuDragData, setMenuDragData] = useState(props?.category);
  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    let replaceArray = [];
    let allData = list;
    const result = Array.from(list.items);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    allData.items = replaceArray;
    allData.items.push(...result);
    store.dispatch({
      type: REORDER_VENDOR_MENU_ITEM,
      payload: allData,
    });
    let formData = {
      status: true,
    };
    store.dispatch({
      type: REORDER_VENDOR_MENU_ITEM_STATUS,
      payload: formData,
    });
    return allData;
  };

  const grid = 2;

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      menuDragData,
      result.source.index,
      result.destination.index
    );
    setMenuDragData(items);
  };

  const dispatch = useDispatch();
  let history = useHistory();

  const [state, setState] = useState({
    monday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 10),
        closing_time: new Date(2020, 1, 1, 12),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 16),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 19),
        closing_time: new Date(2020, 1, 1, 22),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 10),
          closing_time: new Date(2020, 1, 1, 12),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 16),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 19),
          closing_time: new Date(2020, 1, 1, 22),
          description: 'Dinner',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 24),
          closing_time: new Date(2020, 1, 1, 4),
          description: 'Midnight Munching',
        },
      ],
    },
    tuesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    wednesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    thursday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    friday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    saturday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    sunday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
  });

  const [showItem, setShowItem] = useState(false);

  const handleShowItem = (id, event) => {
    setShowItem(!showItem);
    event.stopPropagation();
    // const token = props.auth.user.accessToken;
    // props.get_all_items_from_category(id, token, onSuccess);
  };

  const onDisplayCategoryItem = () => {
    let filteredData = props?.category?.items;
    let itemTypeData = {};

    // filteredData = props?.category?.items.sort((a, b) => {
    //   if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    //   if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    //   return 0;
    // });

    // if (!isEmpty(filteredData)) {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId={props.type}
          type={`droppableSubItem-${props.type}`}
        >
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {menuDragData &&
                menuDragData?.items.map((item, index) => (
                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div>
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          // {...provided.dragHandleProps}
                        >
                          <Row className="border align-items-center py-2 mb-2">
                            <Col xs={2} className="pr-0">
                              <div className="f12-500 text-break">
                                ID {item.ext_id ? item.ext_id : item._id}
                              </div>
                            </Col>
                            <Col xs={2}>
                              <div className="enIMG33 mt-2 rounded">
                                {item && item.images[0] ? (
                                  <Image
                                    //src={require("../../../../../../../assets/images/UserManagement/items.png")}
                                    src={item.images[0]}
                                    alt="Item image"
                                    title="Item image"
                                    fluid
                                    width="100%"
                                    height="100%"
                                  />
                                ) : (
                                  <Image
                                    // src={require("../../../../../../../assets/images/UserManagement/items.png")}
                                    // src={require("../../../../../../../assets/images/MenuImages/imagenotavailable.png")}
                                    src={NOTAVAILABLEIMAGE}
                                    alt="Item image"
                                    title="Item image"
                                    fluid
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                            </Col>
                            <Col xs={3} md={3} className="pl-0">
                              <div className="d-flex align-items-center">
                                {ITEMTYPEVEG.map((type, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      {item?.itemType === type?.value ? (
                                        <img
                                          width="16px"
                                          height="18px"
                                          style={{ position: 'absolute' }}
                                          src={type.url}
                                          alt={type.title}
                                          title={type.title}
                                        />
                                      ) : null}
                                    </React.Fragment>
                                  );
                                })}
                                {/* <SVG
                                  width="16px"
                                  height="18px"
                                  style={{ position: "absolute" }}
                                  src={
                                    item.veg
                                      ? require("../../../../../../../assets/images/UserManagement/veg.svg")
                                      : require("../../../../../../../assets/images/UserManagement/nonveg.svg")
                                  }
                                /> */}
                                <div className="pl-4">
                                  <div className="f11-500">{item.name}</div>
                                  <div className="f11-400">
                                    {item.description}
                                  </div>
                                </div>
                              </div>
                            </Col>
                            {item && item?.currentState !== 9 ? (
                              <Col
                                xs={5}
                                md={4}
                                className="d-flex align-items-center"
                              >
                                <DeleteItem
                                  name={'item'}
                                  id={item._id}
                                  auth={props.auth}
                                  disabled={props.disabled}
                                  delete_item_from_category={
                                    props.delete_item_from_category
                                  }
                                  // extraStyles={{
                                  //   width: "2.82292vw",
                                  //   height: "2.12292vw",
                                  // }}
                                  get_category_menu_setup={
                                    props.get_category_menu_setup
                                  }
                                />
                                <div
                                  style={{
                                    fontSize: '12px',
                                    lineHeight: '10px',
                                    minWidth: '0',
                                    cursor: 'pointer',
                                  }}
                                  className="btnf12_400_HelveticaNeue pr-4 p-1 btn-outline-danger d-flex mobile-min-wid-0"
                                >
                                  <span
                                    onClick={() =>
                                      props.disabled
                                        ? {}
                                        : takeToEditPage(
                                            item._id,
                                            props.category
                                          )
                                    }
                                  >
                                    Continue &nbsp;
                                  </span>
                                  <i className="fa fa-arrow-right"></i>
                                </div>
                              </Col>
                            ) : (
                              <>
                                <Col xs={1} className="pl-0 pr-0">
                                  <div className="f11-500">
                                    <span className="text-red mr-1">₹</span>
                                    {calcPrice(item)}
                                  </div>
                                </Col>
                                <Col
                                  xs={3}
                                  md={3}
                                  className="menusetup-icon-big p-0"
                                >
                                  <div className="d-flex">
                                    <HoursofItemAvailability
                                      disabled={props.disabled}
                                      id={item._id}
                                      closed={false}
                                      ItemName={item.name}
                                      monday={
                                        item.monday.open
                                          ? item.monday.multiple_timings
                                          : []
                                      }
                                      tuesday={
                                        item.tuesday.open
                                          ? item.tuesday.multiple_timings
                                          : []
                                      }
                                      wednesday={
                                        item.wednesday.open
                                          ? item.wednesday.multiple_timings
                                          : []
                                      }
                                      thursday={
                                        item.thursday.open
                                          ? item.thursday.multiple_timings
                                          : []
                                      }
                                      friday={
                                        item.friday.open
                                          ? item.friday.multiple_timings
                                          : []
                                      }
                                      saturday={
                                        item.saturday.open
                                          ? item.saturday.multiple_timings
                                          : []
                                      }
                                      sunday={
                                        item.sunday.open
                                          ? item.sunday.multiple_timings
                                          : []
                                      }
                                    />
                                    <button
                                      className="editIcon-blue mobile-mr-1"
                                      type="button"
                                      onClick={() =>
                                        takeToEditPage(item._id, props.category)
                                      }
                                      disabled={props.disabled}
                                    >
                                      <SVG
                                        src={require('../../../../../../../assets/images/UserManagement/pencil.svg')}
                                      />
                                    </button>
                                    {/* <button className="editIcon-grayBorder" type="button">
                    <SVG
                      src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                    />
                  </button> */}
                                    <DeleteItem
                                      name={'item'}
                                      id={item._id}
                                      auth={props.auth}
                                      disabled={props.disabled}
                                      delete_item_from_category={
                                        props.delete_item_from_category
                                      }
                                      get_category_menu_setup={
                                        props.get_category_menu_setup
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={1}
                                  md={1}
                                  className="menusetup-icon-big p-0"
                                >
                                  <button
                                    type="button"
                                    className="btn btn-link text-dark pr-0 cursor-pointer"
                                    title="Drag"
                                    {...provided.dragHandleProps}
                                  >
                                    <MenuIcon />
                                  </button>
                                </Col>
                              </>
                            )}
                          </Row>
                        </div>
                        {provided.placeholder}
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      // filteredData &&
      // filteredData.map((item, index) => {
      //   return (
      //     <React.Fragment key={index}>
      //       <Row className="align-items-center py-2">
      //         <Col xs={2} className="pr-0">
      //           <div className="f12-500 text-break">
      //             ID {item.ext_id ? item.ext_id : item._id}
      //           </div>
      //         </Col>
      //         <Col xs={2}>
      //           <div className="enIMG33 mt-2 rounded">
      //             {item && item.images[0] ? (
      //               <Image
      //                 //src={require("../../../../../../../assets/images/UserManagement/items.png")}
      //                 src={item.images[0]}
      //                 alt="Item image"
      //                 title="Item image"
      //                 fluid
      //                 width="100%"
      //                 height="100%"
      //               />
      //             ) : (
      //               <Image
      //                 // src={require("../../../../../../../assets/images/UserManagement/items.png")}
      //                 // src={require("../../../../../../../assets/images/MenuImages/imagenotavailable.png")}
      //                 src={DEFAULT_ITEM_IMAGE}
      //                 alt="Item image"
      //                 title="Item image"
      //                 fluid
      //                 width="100%"
      //                 height="100%"
      //               />
      //             )}
      //           </div>
      //         </Col>
      //         <Col xs={3} md={4} className="pl-0">
      //           <div className="d-flex">
      //             <SVG
      //               width="16px"
      //               height="18px"
      //               style={{ position: "absolute" }}
      //               src={
      //                 item.veg
      //                   ? require("../../../../../../../assets/images/UserManagement/veg.svg")
      //                   : require("../../../../../../../assets/images/UserManagement/nonveg.svg")
      //               }
      //             />
      //             <div className="pl-4">
      //               <div className="f11-500">{item.name}</div>
      //               <div className="f11-400">{item.description}</div>
      //             </div>
      //           </div>
      //         </Col>
      //         {item && item?.currentState !== 9 ? (
      //           <Col xs={5} md={4} className="d-flex align-items-center">
      //             <DeleteItem
      //               name={"item"}
      //               id={item._id}
      //               auth={props.auth}
      //               disabled={props.disabled}
      //               delete_item_from_category={
      //                 props.delete_item_from_category
      //               }
      //               // extraStyles={{
      //               //   width: "2.82292vw",
      //               //   height: "2.12292vw",
      //               // }}
      //               get_category_menu_setup={props.get_category_menu_setup}
      //             />
      //             <div
      //               style={{
      //                 fontSize: "12px",
      //                 lineHeight: "10px",
      //                 minWidth: "0",
      //                 cursor: "pointer",
      //               }}
      //               className="btnf12_400_HelveticaNeue pr-4 p-1 btn-outline-danger d-flex mobile-min-wid-0"
      //             >
      //               <span
      //                 onClick={() =>
      //                   props.disabled
      //                     ? {}
      //                     : takeToEditPage(item._id, props.category)
      //                 }
      //               >
      //                 Continue &nbsp;
      //               </span>
      //               <i className="fa fa-arrow-right"></i>
      //             </div>
      //           </Col>
      //         ) : (
      //           <>
      //             <Col xs={1} className="pl-0 pr-0">
      //               <div className="f11-500">
      //                 <span className="text-red mr-1">₹</span>
      //                 {calcPrice(item)}
      //               </div>
      //             </Col>
      //             <Col xs={4} md={3} className="menusetup-icon-big p-0">
      //               <div className="d-flex">
      //                 <HoursofItemAvailability
      //                   disabled={props.disabled}
      //                   id={item._id}
      //                   closed={false}
      //                   ItemName={item.name}
      //                   monday={
      //                     item.monday.open ? item.monday.multiple_timings : []
      //                   }
      //                   tuesday={
      //                     item.tuesday.open
      //                       ? item.tuesday.multiple_timings
      //                       : []
      //                   }
      //                   wednesday={
      //                     item.wednesday.open
      //                       ? item.wednesday.multiple_timings
      //                       : []
      //                   }
      //                   thursday={
      //                     item.thursday.open
      //                       ? item.thursday.multiple_timings
      //                       : []
      //                   }
      //                   friday={
      //                     item.saturday.open
      //                       ? item.friday.multiple_timings
      //                       : []
      //                   }
      //                   saturday={
      //                     item.open ? item.saturday.multiple_timings : []
      //                   }
      //                   sunday={
      //                     item.sunday.open ? item.sunday.multiple_timings : []
      //                   }
      //                 />
      //                 <button
      //                   className="editIcon-blue mobile-mr-1"
      //                   type="button"
      //                   onClick={() =>
      //                     takeToEditPage(item._id, props.category)
      //                   }
      //                   disabled={props.disabled}
      //                 >
      //                   <SVG
      //                     src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
      //                   />
      //                 </button>
      //                 {/* <button className="editIcon-grayBorder" type="button">
      //             <SVG
      //               src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
      //             />
      //           </button> */}
      //                 <DeleteItem
      //                   name={"item"}
      //                   id={item._id}
      //                   auth={props.auth}
      //                   disabled={props.disabled}
      //                   delete_item_from_category={
      //                     props.delete_item_from_category
      //                   }
      //                   get_category_menu_setup={
      //                     props.get_category_menu_setup
      //                   }
      //                 />
      //               </div>
      //             </Col>
      //           </>
      //         )}
      //       </Row>
      //     </React.Fragment>
      //   );
      // })
    );
    // } else {
    //   return null;
    // }
  };

  const takeToCategoryEditPage = (data) => {
    dispatch({ type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP, payload: data });
    if (history.location.pathname.includes('fastfood/menusetup')) {
      history.push('/fastfood/menusetup/addcategory');
    } else if (history.location.pathname.includes('multi-service/menusetup')) {
      history.push('/multi-service/menusetup/addcategory');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/addcategory');
    } else {
      history.push('/casual-fine-dining/menusetup/addcategory');
    }
  };

  const takeToEditPage = (itemId, itemProductClasification) => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: itemId });
    dispatch({ type: BUSINESS_DETAILS_STEP, payload: 1 });
    dispatch({
      type: SET_PRODUCT_CLASSIFCATION,
      payload:
        itemProductClasification &&
        itemProductClasification.product_classification,
    });
    if (history.location.pathname.includes('fastfood/menusetup')) {
      history.push('/fastfood/menusetup/additem', { category: props.category });
    } else if (history.location.pathname.includes('multi-service/menusetup')) {
      history.push('/multi-service/menusetup/additem');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/additemavailablity');
    } else {
      history.push('/casual-fine-dining/menusetup/additem', {
        category: props.category,
      });
    }
  };

  const addNewItem = (categoryData) => {
    dispatch({ type: SET_CURRENT_ITEM_CATEGORY, payload: categoryData });
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: '' });
    dispatch({ type: GET_VENDOR_MENU_CATEGORY_ITEMS, payload: [] });
    dispatch({
      type: SET_PRODUCT_CLASSIFCATION,
      payload: categoryData && categoryData?.product_classification,
    });
    dispatch({
      type: SET_PRODUCT_ACTIVE_CATID,
      payload: categoryData && categoryData?._id,
    });
    dispatch({ type: BUSINESS_DETAILS_STEP, payload: 1 });
    if (history.location.pathname.includes('fastfood/menusetup')) {
      history.push('/fastfood/menusetup/additem', { category: props.category });
    } else if (history.location.pathname.includes('multi-service/menusetup')) {
      history.push('/multi-service/menusetup/additem');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/additemavailablity/frommenu');
    } else {
      history.push('/casual-fine-dining/menusetup/additem', {
        category: props.category,
      });
    }
  };

  const calcPrice = (item) => {
    let price = item.size && item.size[0] && item.size[0].price;
    return price;
  };

  const getTotalItemCount = (item) => {
    // console.log("item ===>", item);
    let totalActiveItem = [];
    for (let i = 0; i < item.length; i++) {
      // console.log("item[i] ===>", item[i]);
      if (item[i].currentState === 9) {
        totalActiveItem.push(item[i]);
      }
    }
    // console.log("totalActiveItem ===>", totalActiveItem);
    return totalActiveItem && totalActiveItem.length;
  };

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="enCategoryListOnboarding">
            <Row className="align-items-center">
              <Col md={4} xs={4}>
                <div className="f12-500">
                  Category : {props.category && props.category.name}
                </div>
                {/* <div className="f16-500">Category :</div> */}
              </Col>
              <Col
                md={8}
                xs={8}
                className="mobile-pl-0 d-flex flex-wrap align-items-center justify-content-end"
              >
                <div className="f12-500 w-25 text-center">
                  No of items :{' '}
                  <span className="f16-500 text-success">
                    {getTotalItemCount(props?.category?.items)}
                  </span>
                </div>
                <button
                  // to="/casual-fine-dining/menusetup/additem"
                  className="btn-sm mr-2 btn btn-outline-secondary"
                  onClick={() => addNewItem(props.category && props.category)}
                  disabled={
                    props.onboarding?.restaurantDetails?.pos?.restId !== ''
                      ? !props.disabled
                      : props.disabled
                  }
                >
                  Add Food Item
                </button>
                <button
                  type="button"
                  disabled={props.disabled}
                  className="enBtnoutlineBlueIcon mr-2"
                  onClick={() => takeToCategoryEditPage(props.category)}
                >
                  <SVG
                    src={require('../../../../../../../assets/images/UserManagement/pencil.svg')}
                  />
                </button>
                <DeleteModal
                  name="Category"
                  disabled={props.disabled}
                  categoryId={props.category && props.category._id}
                  token={props.auth.user.accessToken}
                  delete_category_menu_setup={props.delete_category_menu_setup}
                  get_category_menu_setup={props.get_category_menu_setup}
                  allData={props.category && props.category}
                />

                <button
                  type="button"
                  title="Drop Down"
                  className="btn btn-link ml-2"
                  onClick={(e) => handleShowItem(props.category._id, e)}
                >
                  <SVG
                    src={
                      showItem
                        ? require('../../../../../../../assets/images/UserManagement/up-arrow-box.svg')
                        : require('../../../../../../../assets/images/UserManagement/down-arrow-box.svg')
                    }
                    width="20px"
                    height="20px"
                  />
                </button>
                <button
                  type="button"
                  className="btn btn-link text-dark pr-0"
                  title="Drag"
                  {...props.actionByMain}
                >
                  <MenuIcon />
                </button>
              </Col>
            </Row>
          </div>

          {showItem ? (
            <div className="enSubCategory top-border-merge">
              {onDisplayCategoryItem()}
              {/* {DisplayCombos()} */}
              <DisplayCombos
                combos={props?.category?.combos}
                onboarding={props.onboarding}
                disabled={props.disabled}
                get_category_menu_setup={props.get_category_menu_setup}
                auth={props.auth}
                history={history}
              />

              {/* {props &&
                props.category &&
                props.category.items &&
                props.category.items.map((item, index) => (
                  
                ))} */}

              {/* <Row className="align-items-center py-2">
            <Col md={2}>
              <div className="f12-500">ID 124532</div>
            </Col>
            <Col md={2}>
              <div className="enIMG33 mt-2 rounded">
                <Image
                  src={require("../../../../../../../assets/images/UserManagement/items.png")}
                  alt="View"
                  title="View"
                  fluid
                  width="100%"
                  height="100%"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="d-flex">
                <SVG
                  width="16px"
                  height="18px"
                  src={require("../../../../../../../assets/images/UserManagement/nonveg.svg")}
                />
                <div className="pl-2">
                  <div className="f12-500">Mozzarella Pizza</div>
                  <div className="f11-400">
                    Rich and creamy. Yet, light and fluffy
                  </div>
                </div>
              </div>
            </Col>
            <Col md={1}>
              <div className="f12-500">
                <span className="text-red mr-1">₹</span>250
              </div>
            </Col>

            
            <Col md={3}>
              <div className="d-flex">
                <HoursofItemAvailability
                  id={"ID124563"}
                  closed={false}
                  ItemName={"Item Name"}
                  monday={state.monday.multipleHours}
                  tuesday={state.tuesday.multipleHours}
                  wednesday={state.wednesday.multipleHours}
                  thursday={state.thursday.multipleHours}
                  friday={state.friday.multipleHours}
                  saturday={state.saturday.multipleHours}
                  sunday={state.sunday.multipleHours}
                />
                <button className="editIcon-blue" type="button">
                  <SVG
                    src={require("../../../../../../../assets/images/UserManagement/pencil.svg")}
                  />
                </button>
                <button className="editIcon-grayBorder" type="button">
                  <SVG
                    src={require("../../../../../../../assets/images/UserManagement/Delete.svg")}
                  />
                </button>
              </div>
            </Col>
          </Row> */}
            </div>
          ) : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => {
    if (props.allData?.items.length > 0) {
      Alert.error(`<h4>Please Delete category items</h4>`, {
        position: 'top-right',
        effect: 'bouncyflip',
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      seShowBlockUser(true);
    }
  };

  const onSuccess = () => {
    props.get_category_menu_setup(props.token);
    seShowBlockUser(false);
  };

  const onClickDeleteCategory = () => {
    props.delete_category_menu_setup(props.categoryId, props.token, onSuccess);
  };

  return (
    <React.Fragment>
      {props.redButton ? (
        <div
          className="enIconBtn mr-3"
          onClick={props.disabled ? () => {} : handleShowBlockUser}
        >
          <Image
            src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
            alt="Delete item"
            title="Delete item"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          title="Delete item"
          className="enBtnoutlineGrayIcon"
          onClick={props.disabled ? () => {} : handleShowBlockUser}
        >
          <SVG
            src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={handleCloseBlockUser}
            onClick={() => onClickDeleteCategory()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export const DeleteItem = (props) => {
  const [deleteItem, setDeleteItem] = useState(false);
  const handleDeleteItem = () => setDeleteItem(false);
  const onClickDeleteItem = () => setDeleteItem(true);
  const onClickYesDeleteItem = () => {
    const token = props.auth.user.accessToken;

    props.delete_item_from_category(props.id, token, onSuccess);
  };

  const onSuccess = () => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token);
    Alert.success(`<h4>Item deleted sucessfully</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  return (
    <React.Fragment>
      <div
        className="editIcon-grayBorder cursor mr-1"
        style={props.extraStyles}
        onClick={props.disabled ? () => {} : onClickDeleteItem}
      >
        <Image
          src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
          alt="Delete item"
          title="Delete item"
          fluid
        />
      </div>

      <Modal show={deleteItem} onHide={handleDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={onClickYesDeleteItem}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export const DeleteModalCombo = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => {
    seShowBlockUser(true);
  };

  const onSuccess = () => {
    props.get_category_menu_setup(props.token);
    seShowBlockUser(false);
  };

  const onClickDeleteCombo = (id) => {
    {
      amApi
        .delete(`/combo/${id}`)
        .then((res) => {
          successAlert('Combo Deleted Successfully');

          onSuccess();
        })
        .catch((err) => {
          //  setDisabled(false);
          errorAlert(
            err?.response?.data?.message ||
              'Something went wrong, try again later'
          );
        });
    }
  };

  return (
    <React.Fragment>
      <button
        type="button"
        title="Delete item"
        className="enBtnoutlineGrayIcon"
        onClick={handleShowBlockUser}
      >
        <SVG
          src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
        />
      </button>

      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this combo ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={handleCloseBlockUser}
            onClick={() => onClickDeleteCombo(props?.id)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export const DisplayCombos = ({
  combos,
  onboarding,
  disabled,
  get_category_menu_setup,
  auth,
  history,
}) => {
  const [openCombos, setOpenCombos] = useState({});

  const handleShowCombo = (id) => {
    setOpenCombos((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <>
      {combos?.map((combo) => {
        const comboId = combo[0]?._id;
        return (
          <div key={comboId}>
            <div className="enCategoryListOnboarding">
              <Row className="align-items-center">
                <Col md={4} xs={4}>
                  <div className="f12-500">Combo: {combo[0]?.comboName}</div>
                </Col>
                <Col
                  md={8}
                  xs={8}
                  className="mobile-pl-0 d-flex flex-wrap align-items-center justify-content-end"
                >
                  {/* <button
                    className="btn-sm mr-2 btn btn-outline-secondary"
                    disabled={
                      onboarding?.restaurantDetails?.pos?.restId !== ''
                        ? !disabled
                        : disabled
                    }
                  >
                    Add Food Item
                  </button> */}
                  <button
                    type="button"
                    disabled={disabled}
                    className="enBtnoutlineBlueIcon mr-2"
                    onClick={() => history.push(`editcombo/${combo[0]?._id}`)}
                  >
                    <SVG
                      src={require('../../../../../../../assets/images/UserManagement/pencil.svg')}
                    />
                  </button>
                  <DeleteModalCombo
                    id={combo[0]?._id}
                    token={auth.user.accessToken}
                    get_category_menu_setup={get_category_menu_setup}
                  />
                  <button
                    type="button"
                    title="Drop Down"
                    className="btn btn-link ml-2"
                    onClick={() => handleShowCombo(comboId)}
                  >
                    <SVG
                      src={
                        openCombos[comboId]
                          ? require('../../../../../../../assets/images/UserManagement/up-arrow-box.svg')
                          : require('../../../../../../../assets/images/UserManagement/down-arrow-box.svg')
                      }
                      width="20px"
                      height="20px"
                    />
                  </button>
                </Col>
              </Row>
            </div>

            {openCombos[comboId] && (
              <>
                {combo[0]?.comboItems?.map((comboItem, index) => (
                  <Accordion key={comboItem._id}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                    >
                      <Typography>
                        Category: {comboItem.category_id?.name}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div  style={{width: "100%"}}>
                        <Row>
                          <Col>
                            <h6>Items</h6>
                          </Col>
                        </Row>
                        {comboItem?.items.map((item) => (
                          <Row key={item._id} className="mb-2">
                            <Col md={4}>
                              <div className="enIMG33 mt-2 rounded">
                                {item._id?.images[0] ? (
                                  <Image
                                    src={item._id?.images[0]}
                                    alt="Item image"
                                    fluid
                                    width="100%"
                                    height="100%"
                                  />
                                ) : (
                                  <Image
                                    src={NOTAVAILABLEIMAGE}
                                    alt="Item image"
                                    fluid
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                              <Typography>{item._id?.name}</Typography>
                            </Col>
                            <Col md={4}>
                              <Typography>
                                Additional Price: {item.additionalPrice}
                              </Typography>
                            </Col>
                            <Col md={4}>
                              <Typography>
                                Default: {item.default ? 'Yes' : 'No'}
                              </Typography>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

MenuSetupItem.propTypes = {
  auth: PropTypes.object.isRequired,
  //get_all_items_from_category: PropTypes.func.isRequired,
  delete_item_from_category: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  delete_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  onboarding: state.onboarding && state.onboarding,
});

export default connect(mapStateToProps, {
  delete_item_from_category,
  get_category_menu_setup,
  delete_category_menu_setup,
})(MenuSetupItem);
